import { Task, Note } from "../types";

// Declare puter globally to satisfy TypeScript
declare const puter: any;

export const generateScheduleWithAI = async (
  tasks: Task[], 
  availableHoursPerDay: number,
  daysUntilDeadline: number
): Promise<{ schedule: any[], message: string }> => {
  
  if (!tasks || tasks.length === 0) {
    return { schedule: [], message: "لطفا ابتدا وظایف خود را وارد کنید." };
  }

  const prompt = `
    Act as an expert Persian study planner.
    I have the following tasks to complete: ${JSON.stringify(tasks.map(t => ({ title: t.title, subject: t.subject, priority: t.priority, duration: t.durationMinutes })))}.
    I have ${daysUntilDeadline} days left until my deadline.
    I have approximately ${availableHoursPerDay} hours available per day.

    Please generate a study schedule for the upcoming days.
    
    IMPORTANT: You must return ONLY valid JSON code. Do not include any markdown formatting like \`\`\`json or \`\`\`.
    
    The JSON structure must be:
    {
      "schedule": [
        {
          "day": "Persian Day Name (e.g. شنبه)",
          "focus": "Main subject or theme",
          "tasks": ["Task description 1", "Task description 2"]
        }
      ],
      "message": "A short encouraging message in Persian"
    }

    Prioritize high-priority tasks earlier in the schedule.
  `;

  try {
    const response = await puter.ai.chat(prompt);
    let text = response?.message?.content || "";
    
    // Cleanup potential markdown formatting
    text = text.replace(/```json/g, '').replace(/```/g, '').trim();

    const parsed = JSON.parse(text);
    return parsed;
  } catch (error) {
    console.error("AI Generation Error:", error);
    return { 
      schedule: [], 
      message: "متاسفانه مشکلی در تولید برنامه پیش آمد. لطفا دوباره تلاش کنید." 
    };
  }
};

export const askContextAwareAI = async (
  userMessage: string,
  context: { tasks: Task[], notes: Note[], deadline: string | null }
): Promise<string> => {
  
  const systemInstruction = `
    You are "Golance" (گلنس), a smart and friendly study assistant for students.
    You speak fluent Persian.
    Your goal is to help the user manage their time, reduce stress, and study effectively.
    You have access to the user's current context (tasks, notes, deadline). Use this information to give specific, personalized advice.
    Keep your answers concise, helpful, and motivating.
  `;

  const prompt = `
    ${systemInstruction}

    Context:
    Tasks: ${JSON.stringify(context.tasks.map(t => `${t.title} (${t.priority}, ${t.subject})`))}
    Notes: ${JSON.stringify(context.notes.map(n => `${n.date}: ${n.content}`))}
    Deadline: ${context.deadline ? context.deadline : "Not set"}

    User Question: ${userMessage}
  `;

  try {
    const response = await puter.ai.chat(prompt);
    return response?.message?.content || "متاسفانه نتوانستم پاسخی تولید کنم.";
  } catch (error) {
    console.error("AI Chat Error:", error);
    return "خطا در ارتباط با سرویس هوش مصنوعی.";
  }
};